import { useNavigate } from "react-router-dom";
import { useMount } from "react-use";
import { useSetRecoilState } from "recoil";
import { useMutation } from "react-query";
import useTransition from "react-transition-state";
import { signItem } from "../../states/atoms/signState";
import { signOutUser } from "../../api";
import Loader from "../../components/common/Loader";

const SignOutPage = () => {
  const navigate = useNavigate();
  const setSignInfo = useSetRecoilState(signItem);
  const [{ status }, toggle] = useTransition({
    timeout: 500,
    initialEntered: true,
    preEnter: false,
  });
  const { mutate: onLogout } = useMutation({
    mutationFn: signOutUser,
    onSettled: (data, err) => {
      localStorage.removeItem("token");
      localStorage.removeItem("role");
    },
  });
  useMount(() => {
    toggle();
    const token = localStorage.getItem("token");
    if (token) {
      setSignInfo({ result: false, info: null, error: null });
      onLogout({ token });
    }
    navigate("/");
    window.location.reload();
  });
  return <Loader className={`basic-transition h-screen ${status}`} />;
};

export default SignOutPage;
